(function () {
  if (window.roveitiaCheckoutButtonsReady) return;
  window.roveitiaCheckoutButtonsReady = true;

  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  shopRoot = shopRoot.replace(/\/?$/, '/');
  var addUrl = shopRoot + 'cart/add.js';

  function getProductForm(trigger) {
    return trigger && trigger.closest ? trigger.closest('product-form') : null;
  }

  function getQuantity(productForm) {
    var productInfo = productForm && productForm.closest('product-info');
    var quantityInput = productInfo && productInfo.querySelector('input[name="quantity"]');
    var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;
    return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
  }

  function showError(productForm, message) {
    var wrapper = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    var target = productForm && productForm.querySelector('.product-form__error-message');
    if (wrapper && target) {
      target.textContent = message || 'We could not start checkout. Please try again.';
      wrapper.hidden = false;
      return;
    }
    window.alert(message || 'We could not start checkout. Please try again.');
  }

  function setLoading(trigger, loading) {
    if (!trigger) return;
    trigger.dataset.roveitiaCheckoutLoading = loading ? 'true' : 'false';
    trigger.setAttribute('aria-busy', loading ? 'true' : 'false');
    trigger.style.pointerEvents = loading ? 'none' : '';
    trigger.style.opacity = loading ? '0.72' : '';
  }

  async function startCheckout(event, paymentType) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
    }

    var trigger = event && event.currentTarget;
    if (!trigger || trigger.dataset.roveitiaCheckoutLoading === 'true') return false;

    var productForm = getProductForm(trigger);
    var form = productForm && productForm.querySelector('form[action*="/cart/add"]');
    var variantInput = form && form.querySelector('input[name="id"]');

    if (!form || !variantInput || !variantInput.value) {
      showError(productForm, 'Please select an available option.');
      return false;
    }

    var errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
    if (errorWrapper) errorWrapper.hidden = true;

    setLoading(trigger, true);
    variantInput.disabled = false;

    var formData = new FormData(form);
    formData.set('id', variantInput.value);
    formData.set('quantity', String(getQuantity(productForm)));

    try {
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      var data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'We could not add this item.');
      }

      var checkoutUrl = shopRoot + 'checkout';
      if (paymentType === 'paypal') checkoutUrl += '?payment=paypal';
      window.location.assign(checkoutUrl);
    } catch (error) {
      setLoading(trigger, false);
      showError(productForm, error && error.message);
    }
    return false;
  }

  window.itcProdPagePayPal = function (event) {
    return startCheckout(event, 'paypal');
  };

  window.itcProdPageCheckout = function (event) {
    return startCheckout(event, 'card');
  };
})();
